 

        // <============ on scrll===========
        const navbar = document.querySelector('.main-header');

        window.addEventListener('scroll', () => {
            if (window.scrollY > 100) {
                navbar.classList.add('scrolled');
            } else {
                navbar.classList.remove('scrolled');
            }
        });
        //--------------------------toggle-btn-js------------------------

        $(".navbar-toggler").click(function () {

            $(this).toggleClass('togle');

            $("html").toggleClass("myClass");

        });



               
  $(document).ready(function () {
            $(".hero-banner").owlCarousel({
                loop: true,
                margin: 0,
                nav: false,
                dots: true,
                autoplay: true,
                //autoplayTimeout: 2500,
                autoplayHoverPause: true,
                navText: [
                    "<i class='bi bi-chevron-left'></i>",
                    "<i class='bi bi-chevron-right'></i>"
                ],
                responsive: {
                    0: { items: 1 },
                    768: { items: 1 },
                    1000: { items: 1 }
                }
            });
        });
                  // <========== category-carousel==========>
        $(document).ready(function () {
            $(".category-carousel").owlCarousel({
                loop: true,
                margin: 10,
                nav: true,
                dots: false,
                autoplay: false,
                autoplayTimeout: 2500,
                autoplayHoverPause: true,
                navText: [
                    "<i class='bi bi-chevron-left'></i>",
                    "<i class='bi bi-chevron-right'></i>"
                ],
                responsive: {
                    0: { items: 2 },
                    550:{items: 3},
                    767: { items: 4},
                    1000: { items: 5 },
                    1200: { items: 6 }
                }
            });
        });
        // <========== selling-carousel==========>
        $(document).ready(function () {
            $(".selling-carousel").owlCarousel({
                loop: true,
                margin: 27,
                nav: true,
                dots: false,
                autoplay: false,
                autoplayTimeout: 2500,
                autoplayHoverPause: true,
                navText: [
                    "<i class='bi bi-chevron-left'></i>",
                    "<i class='bi bi-chevron-right'></i>"
                ],
                responsive: {
                    0: { items: 1 },
                    550:{items: 2},
                    1000: { items: 3 },
                    1200: { items: 4 }
                }
            });
        });

        // <========== selling-carousel==========>
        $(document).ready(function () {
            $(".selling-carousel").owlCarousel({
                loop: true,
                margin: 27,
                nav: true,
                dots: false,
                autoplay: false,
                autoplayTimeout: 2500,
                autoplayHoverPause: true,
                navText: [
                    "<i class='bi bi-chevron-left'></i>",
                    "<i class='bi bi-chevron-right'></i>"
                ],
                responsive: {
                    0: { items: 1 },
                    550:{items: 2},
                    1000: { items: 3 },
                    1200: { items: 4 }
                }
            });
        });

        // <========== new-product-carousel==========>
        $(document).ready(function () {
            $(".new-product-carousel").owlCarousel({
                loop: true,
                margin: 27,
                nav: true,
                dots: false,
                autoplay: false,
                autoplayTimeout: 2500,
                autoplayHoverPause: true,
                navText: [
                    "<i class='bi bi-chevron-left'></i>",
                    "<i class='bi bi-chevron-right'></i>"
                ],
                responsive: {
                    0: { items: 1 },
                    600: { items: 2 },
                    1000: { items: 3 },
                     1200: { items: 4 }
                }
            });
        });

        // <========== air-quality--carousel==========>
        // <========== mobile-slider--carousel==========>
    function initOwlCarousel() {
    if ($(window).width() <= 991) {
      if ($('.mobile-slider').hasClass('owl-loaded')) {
        $('.mobile-slider').trigger('destroy.owl.carousel');
        $('.mobile-slider').removeClass('owl-loaded owl-drag');
      }
      
      $('.mobile-slider').owlCarousel({
        items: 1,
        loop: true,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplaySpeed: 600,
        smartSpeed: 600,
        slideBy: 1,
        nav: false,
        dots: false,
        margin: 0,
        stagePadding: 0
      });
    } else {
      if ($('.mobile-slider').hasClass('owl-loaded')) {
        $('.mobile-slider').trigger('destroy.owl.carousel');
        $('.mobile-slider').removeClass('owl-loaded owl-drag');
      }
    }
  }

  initOwlCarousel();

  let resizeTimer;
  $(window).resize(function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      initOwlCarousel();
    }, 250);
  });
        // ============ single products-carouse==========

     $(document).ready(function(){
    var owl = $(".single-product-carousel");

    owl.owlCarousel({
      items:1,
      loop:true,
      nav:false,
      dots:false,
      margin:0
    });

    // Thumbnail click
    $(".thumbnails img").click(function(){
      $(".thumbnails img").removeClass("active");
      $(this).addClass("active");
      var index = $(this).data("index");
      owl.trigger("to.owl.carousel", [index, 300]);
    });

    // Sync thumbnails with carousel
    owl.on("changed.owl.carousel", function(event) {
      var index = event.item.index - event.relatedTarget._clones.length / 2;
      var count = event.item.count;
      if(index < 0) index = count + index;
      if(index >= count) index = index - count;
      $(".thumbnails img").removeClass("active").eq(index).addClass("active");
    });
  });


// ======== QUANTITY =====================
const minus = document.querySelector(".minus");
const plus = document.querySelector(".plus");
const input = document.querySelector(".quantity input");

// Pehle check karo ki elements exist karte hain
if (minus && plus && input) {
  let value = parseInt(input.value) || 1;

  plus.addEventListener("click", () => {
    value++;
    input.value = value;
  });

  minus.addEventListener("click", () => {
    if (value > 1) {
      value--;
      input.value = value;
    }
  }); 
}

   // <========== related products-carousel==========>
        $(document).ready(function () {

            $(".related-product-carousel").owlCarousel({
                loop: true,
                margin: 27,
                nav: true,
                dots: false,
                autoplay: false,
                autoplayTimeout: 2500,
                autoplayHoverPause: true,
                navText: [
                    "<i class='bi bi-chevron-left'></i>",
                    "<i class='bi bi-chevron-right'></i>"
                ],
                responsive: {
                    0: { items: 1 },
                    550:{items: 2},
                    1000: { items: 3 },
                    1200: { items: 4 }
                }
            });

        });

     

        /**
 * nav-bar.js  —  assets/nav-bar.js
 *
 * Requires jQuery (already loaded in your theme).
 * Matches your existing CSS / design system exactly.
 * Load before </body>:
 *   {{ 'nav-bar.js' | asset_url | script_tag }}
 */

$(function () {
  'use strict';

  var hoverTimer;

  function isMobile() {
    return $(window).width() <= 1199;
  }

  /* ── DESKTOP ONLY: hover open/close ─────────────────── */
  $('.nav-item[data-menu]').on('mouseenter', function () {
    if (isMobile()) return;   // ← skip hover logic on mobile
    clearTimeout(hoverTimer);
    var id = $(this).data('menu');
    closeAll();
    $(this).addClass('active').attr('aria-expanded', 'true');
    $('#' + id).stop(true, true).slideDown(160);
    $('#overlay').fadeIn(150);
  });

  $('.nav-bar, .mega-menu').on('mouseenter', function () {
    if (isMobile()) return;
    clearTimeout(hoverTimer);
  });

  $('.nav-bar, .mega-menu').on('mouseleave', function () {
    if (isMobile()) return;
    hoverTimer = setTimeout(function () {
      closeAll();
    }, 120);
  });

  /* ── MOBILE ONLY: tap/click to toggle ───────────────── */
/* ── MOBILE ONLY: tap/click to toggle ───────────────── */
$('.nav-item[data-menu]').on('click', function (e) {
  if (!isMobile()) return;
  var id    = $(this).data('menu');
  var $menu = $('#' + id);
  var isOpen = $(this).hasClass('active');

  closeAll();
  if (!isOpen) {
    $(this).addClass('active').attr('aria-expanded', 'true');
    $menu.slideDown(200);
  }
});

// Anchor click pe sirf redirect, dropdown toggle nahi
$('.nav-item[data-menu] a').on('click', function (e) {
  if (!isMobile()) return;
  var $navItem = $(this).closest('.nav-item');

  if ($navItem.hasClass('active')) {
    // Dropdown already open hai → redirect hone do
    return;
  }

  // Dropdown closed hai → redirect rokho, sirf open karo
  e.preventDefault();
  e.stopPropagation();
  closeAll();
  $navItem.addClass('active').attr('aria-expanded', 'true');
  $('#' + $navItem.data('menu')).slideDown(200);
});

  /* ── KEYBOARD: Enter / Space / Escape ───────────────── */
  $('.nav-item[data-menu]').on('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      var id     = $(this).data('menu');
      var $menu  = $('#' + id);
      var isOpen = $(this).hasClass('active');
      closeAll();
      if (!isOpen) {
        $(this).addClass('active').attr('aria-expanded', 'true');
        $menu.slideDown(160);
        if (!isMobile()) $('#overlay').fadeIn(150);
      }
    }
    if (e.key === 'Escape') { closeAll(); }
  });

  $(document).on('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  /* ── OVERLAY click ───────────────────────────────────── */
  $('#overlay').on('click', function () { closeAll(); });

  /* ── HAMBURGER ───────────────────────────────────────── */
  $('#hamburger').on('click', function () {
    $(this).toggleClass('open');
    $('#navBar').toggleClass('mobile-open');
  });

  /* ── MOBILE CLOSE BUTTON ─────────────────────────────── */
  $('#mobileClose').on('click', function () {
    $('#hamburger').removeClass('open');
    $('#navBar').removeClass('mobile-open');
    closeAll();
  });

  /* ── HELPER ──────────────────────────────────────────── */
  function closeAll() {
    $('.nav-item').removeClass('active').attr('aria-expanded', 'false');
    $('.mega-menu').stop(true, true).slideUp(140);
    $('#overlay').fadeOut(150);
  }

});